import DueCreateFirstStep from '../../views/due/create/DueCreateFirstStep';
import DueCreateSecondStep from '../../views/due/create/DueCreateSecondStep';
import DueContactLawyersSpecificBeneficiaryStep from '../../views/due/create/DueContactLawyersSpecificBeneficiaryStep';
import DueContactLawyersNoCcnStep from '../../views/due/create/DueContactLawyersNoCcnStep';
import DueCreateThirdStep from '../../views/due/create/DueCreateThirdStep';
import DueCreateFourthStep from '../../views/due/create/DueCreateFourthStep';
import DueCreateFifthStep from '../../views/due/create/DueCreateFifthStep';
import DueCreateSixthStep from '../../views/due/create/DueCreateSixthStep';
import DueCreateSeventhStep from '../../views/due/create/DueCreateSeventhStep';
import DueList from '../../views/due/list/DueList';
import DueLegalRepresentativeComplete from '../../views/due/DueLegalRepresentativeComplete';
import { isCanDuesAction, isCanViewDues, isCanMakeDueEffective } from "@/router/permission";
import DueMakeEffectiveStep from "@/views/due/create/DueMakeEffectiveStep";
import DueDownloadByToken from '../../views/due/DueDownloadByToken';
import DueAmendmentStep from "@/views/due/create/DueAmendmentStep";

export default [
    {
        path: '/due/first-step/:id?',
        name: 'due-first-step',
        component: DueCreateFirstStep,
        meta: { isAuthRequired: true, isEnterpriseRequired: true },
        beforeEnter: isCanDuesAction,
        props: true
    },
    {
        path: '/due/second-step/:id?',
        name: 'due-second-step',
        component: DueCreateSecondStep,
        meta: { isAuthRequired: true, isEnterpriseRequired: true },
        beforeEnter: isCanDuesAction
    },
    {
        path: '/due/third-step/:id?',
        name: 'due-third-step',
        component: DueCreateThirdStep,
        meta: { isAuthRequired: true, isEnterpriseRequired: true },
        beforeEnter: isCanDuesAction
    },
    {
        path: '/due/fourth-step/:id?',
        name: 'due-fourth-step',
        component: DueCreateFourthStep,
        meta: { isAuthRequired: true, isEnterpriseRequired: true },
        beforeEnter: isCanDuesAction
    },
    {
        path: '/due/fifth-step/:id?',
        name: 'due-fifth-step',
        component: DueCreateFifthStep,
        meta: { isAuthRequired: true, isEnterpriseRequired: true },
    },
    {
        path: '/due/sixth-step/:id?',
        name: 'due-sixth-step',
        component: DueCreateSixthStep,
        meta: { isAuthRequired: true, isEnterpriseRequired: true },
        beforeEnter: isCanDuesAction
    },
    {
        path: '/due/seventh-step/:id?',
        name: 'due-seventh-step',
        component: DueCreateSeventhStep,
        meta: { isAuthRequired: true, isEnterpriseRequired: true },
        beforeEnter: isCanDuesAction
    },
    {
        path: '/due/beneficiary-contact-lawyers',
        name: 'due-beneficiary-contact-lawyers',
        component: DueContactLawyersSpecificBeneficiaryStep,
        meta: { isAuthRequired: true, isEnterpriseRequired: true },
    },
    {
        path: '/due/no-ccn-contact-lawyers',
        name: 'due-no-ccn-contact-lawyers',
        component: DueContactLawyersNoCcnStep,
        meta: { isAuthRequired: true, isEnterpriseRequired: true },
    },
    {
        path: '/due/list',
        name: 'due-list',
        component: DueList,
        meta: { isAuthRequired: true, isEnterpriseRequired: true },
        beforeEnter: isCanViewDues
    },
    {
        path: '/due/:dueAccessToken/legal-representative-complete',
        name: 'due-legal-representative-complete',
        component: DueLegalRepresentativeComplete,
    },
    {
        path: '/due/:id/make-effective',
        name: 'due-make-effective',
        component: DueMakeEffectiveStep,
        beforeEnter: isCanMakeDueEffective
    },
    {
        path: '/due/employee-emails/:dueAccessToken',
        name: 'due-employee-emails-download-by-token',
        component: DueDownloadByToken
    },
    {
        path: '/due/:id/amendment',
        name: 'due-amendment',
        component: DueAmendmentStep,
        beforeEnter: isCanDuesAction
    }
];
